/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signup_Legal_Entity_IcoInputs */

const cs_auth_signup_legal_entity_ico = /** @type {(inputs: Auth_Signup_Legal_Entity_IcoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IČO`)
};

const en_auth_signup_legal_entity_ico = /** @type {(inputs: Auth_Signup_Legal_Entity_IcoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IČO`)
};

/**
* | output |
* | --- |
* | "IČO" |
*
* @param {Auth_Signup_Legal_Entity_IcoInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_signup_legal_entity_ico = /** @type {((inputs?: Auth_Signup_Legal_Entity_IcoInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signup_Legal_Entity_IcoInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_signup_legal_entity_ico(inputs)
	return cs_auth_signup_legal_entity_ico(inputs)
});